import type { SILogReport } from '../models/report';
import { useMovedProductsReport } from './logYard/movedProducts/movedProductsReport';
import { usePeriodReport } from './logYard/period/periodReport';
import { useStatusReport } from './logYard/status/statusReport';
import { useVehicleReport } from './logYard/vehicleMoves/vehicleMovesReport';
import { useVehicleStatisticsReport } from './logYard/vehicleStatistics/vehicleStatisticsReport';

export function listInstalledReports(): SILogReport[] {
  const statusReport = useStatusReport();
  const periodReport = usePeriodReport();
  const vehicleMovesReport = useVehicleReport();
  const movedProductsReport = useMovedProductsReport();
  const vehicleStatisticsReport = useVehicleStatisticsReport();

  return [
    statusReport,
    periodReport,
    vehicleMovesReport,
    movedProductsReport,
    vehicleStatisticsReport,
  ];
}
